import AssetDashboard from '@pages/AssetDashboard/AssetDashboard.vue';
import AssetReports from '@pages/AssetReports/AssetReports.vue';
import AssetSettingTabs from '@pages/AssetSettings/AssetSettingTabs.vue';
import PhaseList from '@pages/AssetTimeline/PhaseList.vue';
import ActivateUser from '@pages/Authentication/ActivateUser.vue';
import Login from '@pages/Authentication/Login.vue';
import ResetPassword from '@pages/Authentication/ResetPassword.vue';
import ResetPasswordConfirm from '@pages/Authentication/ResetPasswordConfirm.vue';
import CategoryDetail from '@pages/Causes/CategoryDetail.vue';
import CategoryList from '@pages/Causes/CategoryList.vue';
import CauseDetail from '@pages/Causes/CauseDetail.vue';
import CauseList from '@pages/Causes/CauseList.vue';
import CauseTabs from '@pages/Causes/CauseTabs.vue';
import DeviceManagement from '@pages/DeviceManagement/DeviceManagement.vue';
import Error404 from '@pages/Error404.vue';
import ErrorPage from '@pages/ErrorPage.vue';
import EventDetail from '@pages/EventList/EventDetail.vue';
import EventList from '@pages/EventList/EventList.vue';
import FacilityDashboard from '@pages/FacilityDashboard.vue';
import FacilityDetail from '@pages/FacilityDetail.vue';
import FacilityList from '@pages/FacilityList.vue';
import FacilitySettings from '@pages/FacilitySettings.vue';
import GroupDetail from '@pages/GroupDetail.vue';
import GroupList from '@pages/GroupList.vue';
import ProductCategories from '@pages/ProductCategories.vue';
import ProductCategoryDetail from '@pages/ProductCategoryDetail.vue';
import ProductDetail from '@pages/ProductDetail.vue';
import ProductList from '@pages/ProductList.vue';
import ProductPropertyDetail from '@pages/ProductPropertyDetail.vue';
import QualityDefectDetail from '@pages/Quality/QualityDefectDetail.vue';
import QualityDefectList from '@pages/Quality/QualityDefectList.vue';
import QualityEventsList from '@pages/Quality/QualityEventsList.vue';
import AutomaticReportDetail from '@pages/Report/AutomaticReports/AutomaticReportDetail.vue';
import AutomaticReportList from '@pages/Report/AutomaticReports/AutomaticReportList.vue';
import ReportSelect from '@pages/Report/ReportSelect.vue';
import Reports from '@pages/Report/Reports.vue';
import Settings from '@pages/Settings.vue';
import UserProfileResetPassword from '@pages/UserProfileResetPassword.vue';
import ShiftList from '@pages/ShiftList.vue';
import SystemStatus from '@pages/SystemStatus.vue';
import UserDetail from '@pages/UserDetail.vue';
import UserList from '@pages/UserList.vue';
import UserProfile from '@pages/UserProfile.vue';
import Auth from '../layouts/Auth.vue';
import Layout from '../layouts/Layout.vue';
import OAuthComplete from '@pages/Authentication/OAuthComplete.vue';

const routes = [
    // authentication
    {
        name: 'auth',
        path: '/auth',
        component: Auth,
        meta: {
            isPublic: true
        },
        children: [
            // user login
            {
                name: 'login',
                path: 'login',
                props: false,
                meta: {
                    isPublic: true
                },
                component: Login
            },
            // user account activation
            {
                name: 'activate_user',
                path: 'activate/:uid/:token',
                props: true,
                meta: {
                    isPublic: true
                },
                component: ActivateUser
            },
            // reset password
            {
                name: 'reset_password',
                path: 'reset_password',
                props: false,
                meta: {
                    isPublic: true
                },
                component: ResetPassword
            },
            // confirm reset password
            {
                name: 'reset_password_confirm',
                path: 'password/confirm/:uid/:token',
                props: true,
                meta: {
                    isPublic: true
                },
                component: ResetPasswordConfirm
            }
        ]
    },
    // oauth complete
    {
        name: 'oauth_complete',
        path: '/oauth/complete/',
        props: false,
        meta: {
            isPublic: true
        },
        component: OAuthComplete
    },
    // favicon
    {
        path: '/favicon.ico',
        redirect: '/public/favicon.ico',
        meta: {
            isPublic: true
        }
    },
    // robots.txt
    {
        path: '/robots.txt',
        redirect: '/public/robots.txt',
        meta: {
            isPublic: true
        }
    },
    // error page
    {
        name: 'error',
        path: '/error',
        props: true,
        meta: {
            isPublic: true
        },
        component: ErrorPage
    },
    {
        path: '/',
        component: Layout,
        meta: {
            isPublic: false
        },
        children: [
            // reports
            {
                name: 'reports_select',
                path: 'reports',
                props: true,
                component: ReportSelect
            },
            {
                name: 'kpi',
                path: 'reports/kpi',
                props: true,
                component: Reports
            },
            {
                name: 'trends',
                path: 'reports/trends',
                props: true,
                component: Reports
            },
            {
                name: 'losses',
                path: 'reports/losses',
                props: true,
                component: Reports
            },
            {
                name: 'data_entry_performance',
                path: 'reports/data_entry_performance',
                props: true,
                component: Reports
            },
            {
                name: 'maintenance',
                path: 'reports/maintenance',
                props: true,
                component: Reports
            },
            {
                name: 'quality',
                path: 'reports/quality',
                props: true,
                component: Reports
            },
            {
                name: 'changeover',
                path: 'reports/changeover',
                props: true,
                component: Reports
            },
            {
                name: 'benchmark',
                path: 'reports/benchmark',
                props: true,
                component: Reports
            },

            // automatic reports
            {
                name: 'automatic_report_list',
                path: 'reports/automatic_reports',
                props: true,
                component: AutomaticReportList
            },
            {
                name: 'automatic_report_create',
                path: 'reports/automatic_reports/create',
                props: true,
                component: AutomaticReportDetail
            },
            {
                name: 'automatic_report_update',
                path: 'reports/automatic_reports/:id',
                props: true,
                component: AutomaticReportDetail
            },
            // facilities
            {
                alias: '',
                name: 'facility_list',
                path: 'facilities',
                props: true,
                component: FacilityList
            },
            {
                name: 'facility_detail',
                path: 'facilities/:facilityId/detail',
                props: true,
                component: FacilityDetail
            },
            {
                name: 'facility_dashboard',
                path: 'facilities/:facilityId/',
                props: true,
                component: FacilityDashboard
            },
            {
                name: 'facility_settings',
                path: 'facilities/:facilityId/settings',
                props: true,
                component: FacilitySettings
            },

            // assets
            {
                name: 'asset_settings',
                path: 'facilities/:facilityId/assets/:assetId',
                props: true,
                component: AssetSettingTabs
            },
            {
                name: 'asset_dashboard',
                path: 'facilities/:facilityId/assets/:assetId/dashboard',
                props: true,
                component: AssetDashboard
            },
            {
                name: 'asset_reports',
                path: 'facilities/:facilityId/assets/:assetId/reports',
                props: true,
                component: AssetReports
            },
            {
                name: 'asset_cause_list',
                path: 'facilities/:facilityId/assets/:assetId/causes',
                props: true,
                component: CauseList
            },
            {
                name: 'asset_events',
                path: 'facilities/:facilityId/assets/:assetId/events',
                props: true,
                component: EventList
            },
            {
                name: 'asset_products',
                path: 'facilities/:facilityId/assets/:assetId/products',
                props: true,
                component: ProductList
            },
            {
                name: 'asset_timeline',
                path: 'facilities/:facilityId/assets/:assetId/timeline',
                props: true,
                component: PhaseList
            },

            // causes
            {
                name: 'cause_list',
                path: 'facilities/:facilityId/causes',
                props: true,
                component: CauseTabs
            },
            {
                name: 'cause_create',
                path: 'facilities/:facilityId/causes/create',
                props: true,
                component: CauseDetail
            },
            {
                name: 'cause_update',
                path: 'facilities/:facilityId/causes/:causeId',
                props: true,
                component: CauseDetail
            },

            // quality defects
            {
                name: 'quality_defect_list',
                path: 'facilities/:facilityId/quality',
                props: true,
                component: QualityDefectList
            },
            {
                name: 'quality_defect_create',
                path: 'facilities/:facilityId/quality/create',
                props: true,
                component: QualityDefectDetail
            },
            {
                name: 'quality_defect_update',
                path: 'facilities/:facilityId/quality/:qualityDefectId',
                props: true,
                component: QualityDefectDetail
            },

            // categories
            {
                name: 'category_list',
                path: 'facilities/:facilityId/categories',
                props: true,
                component: CategoryList
            },
            {
                name: 'category_create',
                path: 'facilities/:facilityId/categories/create',
                props: true,
                component: CategoryDetail
            },
            {
                name: 'category_update',
                path: 'facilities/:facilityId/categories/:categoryId',
                props: true,
                component: CategoryDetail
            },

            // events
            {
                name: 'event_list',
                path: 'facilities/:facilityId/events',
                props: true,
                component: EventList
            },
            {
                name: 'event_create',
                path: 'facilities/:facilityId/events/create',
                props: true,
                component: EventDetail
            },
            {
                name: 'event_update',
                path: 'facilities/:facilityId/events/:eventId',
                props: true,
                component: EventDetail
            },

            // quality events
            {
                name: 'quality_event_list',
                path: 'facilities/:facilityId/quality_events',
                props: true,
                component: QualityEventsList
            },

            // products
            {
                name: 'product_list',
                path: 'facilities/:facilityId/products',
                props: true,
                component: ProductList
            },
            {
                name: 'product_create',
                path: 'facilities/:facilityId/products/create',
                props: true,
                component: ProductDetail
            },
            {
                name: 'product_update',
                path: 'facilities/:facilityId/products/:productId',
                props: true,
                component: ProductDetail
            },

            // users
            {
                name: 'user_list',
                path: 'settings/users',
                props: true,
                component: UserList
            },
            {
                name: 'user_create',
                path: 'settings/users/create',
                props: true,
                component: UserDetail
            },
            {
                name: 'user_update',
                path: 'settings/users/:userId',
                props: true,
                component: UserDetail
            },

            // current user
            {
                name: 'profile',
                path: 'profile',
                props: true,
                component: UserProfile
            },
            {
                name: 'reset_password_from_profile',
                path: '/profile/password_reset',
                props: true,
                component: UserProfileResetPassword
            },
            {
                name: 'settings',
                path: 'settings',
                props: false,
                component: Settings
            },
            // shifts
            {
                name: 'shift_list',
                path: 'facilities/:facilityId/shift_list',
                props: true,
                component: ShiftList
            },

            {
                name: 'system_status',
                path: '/settings/system_status',
                props: false,
                component: SystemStatus
            },

            // Device Management
            {
                name: 'device_management',
                path: '/settings/device_management',
                props: false,
                component: DeviceManagement
            },

            // Asset Groups
            {
                name: 'group_list',
                path: 'facilities/:facilityId/groups',
                props: true,
                component: GroupList
            },
            {
                name: 'group_create',
                path: 'facilities/:facilityId/groups/create',
                props: true,
                component: GroupDetail
            },
            {
                name: 'group_update',
                path: 'facilities/:facilityId/groups/:groupId/update',
                props: true,
                component: GroupDetail
            },
            {
                name: 'product_categories',
                path: '/settings/product_categories',
                props: true,
                component: ProductCategories
            },
            {
                name: 'product_category_detail',
                path: '/settings/product_categories/create',
                props: true,
                component: ProductCategoryDetail
            },
            {
                name: 'product_property_detail',
                path: '/settings/product_properties/create',
                props: true,
                component: ProductPropertyDetail
            }
        ]
    }
];

// Always leave this as last one
routes.push({
    name: '404',
    path: '/:catchAll(.*)*',
    component: Error404
});

export default routes;
